export default __webpack_public_path__ + "static/media/booth_5_pfizer.b8473f2a.png";